var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DA79956A-9641-4BE9-8EA5-9AA7E73D90E1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 8.66666667,
    cy: 8.66666667,
    r: 8.66666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Login-&-Sign-Up-\\u2728",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up-1",
    transform: "translate(-324.000000, -331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Help",
    transform: "translate(323.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    strokeWidth: 1,
    transform: "translate(1.333333, 1.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A9CF60",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Gray/Gray-4",
    mask: "url(#mask-2)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.333333, -1.333333)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M8.70442708,11.9414062 C8.70442708,11.3077225 8.77604095,10.8075105 8.91927083,10.4407552 C9.06250072,10.0739999 9.29470326,9.75607773 9.61588542,9.48697917 C9.93706758,9.2178806 10.1812058,8.9715723 10.3483073,8.74804688 C10.5154088,8.52452145 10.5989583,8.27821315 10.5989583,8.00911458 C10.5989583,7.35372936 10.3168431,7.02604167 9.75260417,7.02604167 C9.4921862,7.02604167 9.28168483,7.12152682 9.12109375,7.3125 C8.96050267,7.50347318 8.8758681,7.76171712 8.8671875,8.08723958 L6.66666667,8.08723958 C6.67534727,7.21917969 6.94878203,6.54318818 7.48697917,6.05924479 C8.0251763,5.5753014 8.78037708,5.33333333 9.75260417,5.33333333 C10.720491,5.33333333 11.4702664,5.5568554 12.0019531,6.00390625 C12.5336398,6.4509571 12.7994792,7.08680143 12.7994792,7.91145833 C12.7994792,8.27170319 12.7278653,8.59939089 12.5846354,8.89453125 C12.4414055,9.18967161 12.2113731,9.4913179 11.8945312,9.79947917 L11.1458333,10.4960938 C10.9331587,10.7000878 10.7855907,10.9095041 10.703125,11.124349 C10.6206593,11.3391938 10.5750868,11.6115435 10.5664062,11.9414062 L8.70442708,11.9414062 Z M8.4375,13.9205729 C8.4375,13.5993908 8.55360127,13.3357215 8.78580729,13.1295573 C9.01801331,12.9233931 9.30772396,12.8203125 9.65494792,12.8203125 C10.0021719,12.8203125 10.2918825,12.9233931 10.5240885,13.1295573 C10.7562946,13.3357215 10.8723958,13.5993908 10.8723958,13.9205729 C10.8723958,14.2417551 10.7562946,14.5054243 10.5240885,14.7115885 C10.2918825,14.9177528 10.0021719,15.0208333 9.65494792,15.0208333 C9.30772396,15.0208333 9.01801331,14.9177528 8.78580729,14.7115885 C8.55360127,14.5054243 8.4375,14.2417551 8.4375,13.9205729 Z",
    id: "?",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3c7946a9670b7fd4d82df3052c6e5112.svg";
export { ForwardRef as ReactComponent };